module.exports = __webpack_public_path__ + "img/pp-49.c0350450.jpg";